<template>
  <div id="weeklyReportUser">
		<el-collapse v-model="activeNames">
      <el-collapse-item title="Leadership Team Information" name="1">
				<el-button type="primary" size="small" style="margin-bottom: 10px" icon="el-icon-plus" @click="openEditDialog(1)" v-if="allData && allData.projectStatus !== 5">Add</el-button>
				<el-table :data="tableData1" size="small" border style="margin-bottom: 10px; width: 100%" v-loading="tableLoading1" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
					<el-table-column label="No." prop="number" align="center" min-width="78"></el-table-column>
					<el-table-column prop="memberName" label="Name" align="center" min-width="180"></el-table-column>
					<el-table-column prop="memberNo" label="ID" align="center" min-width="150"></el-table-column>
					<el-table-column prop="memberPosition" label="Job Title" align="center" min-width="260"></el-table-column>
					<el-table-column prop="operation" label="Operation" align="center" min-width="180">
						<template slot-scope="scope" v-if="allData && allData.projectStatus !== 5">
							<el-button type="primary" size="small" @click="openEditDialog(1, scope.row)">Edit</el-button>
							<el-button type="danger" size="small" @click="handleDelete(1, scope.row)">Delete</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="pageDiv" v-if="totalCount1 && totalCount1 > 0" style="padding-bottom: 15px">
					<el-pagination
						small
						layout="total, prev, pager, next, sizes, jumper"
						:page-sizes="[10, 20, 50, 100]"
						:current-page="currentPage1"
						:page-size="pageSize1"
						:total="totalCount1"
						@size-change=" values => changePageSize(values, 1)"
						@current-change=" values => changePage(values, 1)"
					>
					</el-pagination>
				</div>
			</el-collapse-item>
			<el-collapse-item title="Execute Group Information" name="2">
				<el-button type="primary" size="small" style="margin-bottom: 10px" icon="el-icon-plus" @click="openEditDialog(2)" v-if="allData && allData.projectStatus !== 5">Add</el-button>
				<el-table :data="tableData2" size="small" border style="margin-bottom: 10px; width: 100%" v-loading="tableLoading2" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
					<el-table-column label="No." prop="number" align="center" min-width="78"></el-table-column>
					<el-table-column prop="memberName" label="Name" align="center" min-width="180"></el-table-column>
					<el-table-column prop="memberNo" label="ID" align="center" min-width="150"></el-table-column>
					<el-table-column prop="memberPosition" label="Job Title" align="center" min-width="260"></el-table-column>
					<el-table-column prop="operation" label="Operation" align="center" min-width="180">
						<template slot-scope="scope" v-if="allData && allData.projectStatus !== 5">
							<el-button type="primary" size="small" @click="openEditDialog(2, scope.row)">Edit</el-button>
							<el-button type="danger" size="small" @click="handleDelete(2, scope.row)">Delete</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="pageDiv" v-if="totalCount2 && totalCount2 > 0" style="padding-bottom: 15px">
					<el-pagination
						small
						layout="total, prev, pager, next, sizes, jumper"
						:page-sizes="[10, 20, 50, 100]"
						:current-page="currentPage2"
						:page-size="pageSize2"
						:total="totalCount2"
						@size-change=" values => changePageSize(values, 2)"
						@current-change=" values => changePage(values, 2)"
					>
					</el-pagination>
				</div>
			</el-collapse-item>
		</el-collapse>
		<el-dialog
			title="Edit"
			width="500px"
			:visible.sync="editDialog"
			:close-on-click-modal="false"
			:destroy-on-close="true"
		>
			<el-form :model="editForm" ref="editForm" label-width="85px">
				<el-form-item label="Name:" prop="memberNo" :rules="[{ required: true, message: 'Please input' }]">
					<el-select
						v-model="editForm.memberNo"
						clearable
						filterable
						remote
						placeholder="Please input"
						:remote-method="value => remoteMethod('userList', value)"
						@change="changUser"
					>
						<el-option v-for="(item, index) in userList.slice(0, 10)" :key="index" :label="item.userCode" :value="item.empCode"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="Job Title:" prop="memberPosition" :rules="[{ required: true, message: 'Please input' }]">
					<el-input clearable v-model="editForm.memberPosition" maxlength="255" placeholder="Please input" />
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="closeEdit()">Cancel</el-button>
				<el-button type="primary" :loading="confirmLoading" size="small" @click="confirmUser()">Confirm</el-button>
			</span>
		</el-dialog>
  </div>
</template>
<script>
  import {_debounce} from '@/utils/selectAPI'
  import * as validate from '@/utils/validate'
	import axios from 'axios'
  export default {
    name: 'weeklyReportUser',
    created () {
			this.handleSearch(1);
			this.handleSearch(2);
		},
		props: {
			id: {
        type: Number,
        default: null,
      },
			allData: {
				type: Object,
        default: {},
			},
		},
		watch: {
		},
		computed: {
			tableData1() {
				const start = (this.currentPage1 - 1) * this.pageSize1;
				const end = start + this.pageSize1;
				return this.allTableData1.slice(start, end);
			},
			tableData2() {
				const start = (this.currentPage2 - 1) * this.pageSize2;
				const end = start + this.pageSize2;
				return this.allTableData2.slice(start, end);
			}
		},
    data () {
      return {
				activeNames: ['1', '2'],
				recipientDialog: false,
				allTableData1: [],
				allTableData2: [],
				// tableData1: [],
				// tableData2: [],
				tableLoading1: false,
				tableLoading2: false,
				currentPage1: 1,
				currentPage2: 1,
				pageSize1: 10,
				pageSize2: 10,
				totalCount1: 1,
				totalCount2: 1,
				exportLoading: false,
				editDialog: false,
				editForm: {},
				confirmLoading: false,
				userList: [],
				roleList: ['Team Leader', 'Deputy Team Leader', 'Team Member'],
				editType: '',
      }
    },
    methods: {
			handleSearch(type) {
				let params = {
					islhToken : sessionStorage.getItem('islhtoken'),
					majorProjectId: this.id,
					memberType: type,
				}
				this['tableLoading' + type ] = true;
				let url =`${this.$store.state.islhurl}majorProjectMember/getList`
				this._post(url,params).then(
					res => {
						this['tableLoading' + type ] = false;
						if(res.code === 200) {
							let newData = [];
							res.data.forEach((item, index) => {
								newData.push({
									...item,
									number: index + 1,
								})
							});
							this['allTableData' + type ] = newData;
							this['totalCount' + type ] = res.data.length;
						} else {
							this['allTableData' + type ] = [];
							this.$message.error(res.message || 'Failed!' );
						}
					}
				)
			},
			changePageSize(size, type) {
				this['pageSize' + type ] = size;
			},
			changePage(current, type) {
				this['currentPage' + type ] = current;
			},
			remoteMethod(list, query) {
				if (query !== '') {
					// 清除之前的定时器
					if (this.timeout) {
						clearTimeout(this.timeout)
					}
					// 防抖处理，300ms后执行
					this.timeout = setTimeout(() => {
						this.fetchUserOptions(list, query)
					}, 200)
				} else {
					this[list] = []
				}
			},
			fetchUserOptions(list, query) {
				let url =`${this.$store.state.islhurl}user/select-option?keyword=${query}`;
				this._get(url).then().then(res => {
					if(res.code === 200 && res.data) {
						this[list] = res.data;
					} else {
						this[list] = [];
					}
				}).catch(error => {
					this[list] = [];
					console.error('搜索失败:', error)
				})
			},
			changUser(value) {
				const selectedOption = this.userList.find(option => option.empCode === value);
				this.editForm.memberNo = value;
				this.editForm.memberName = selectedOption.empName;
			},
			openEditDialog(type, row) {
				this.editDialog = true;
				this.editType = type;
				if(row && row.memberNo) {
					this.editForm = {
						...row,
					};
					this.remoteMethod('userList', row.memberNo)
				}
			},
			closeEdit() {
				this.editDialog = false;
				this.editType = '';
				this.editForm = {};
			},
      handleDelete(type, row) {
        this.$confirm("Are you sure to delete", "Warning", {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          let url = `${this.$store.state.islhurl}majorProjectMember/delete?id=${row.id}&&majorProjectId=${this.id}&&islhToken=${sessionStorage.getItem('islhtoken')}`
          this._post(url).then(
            res => {
              if(res.code === 200) {
                this.handleSearch(type);
                this.$Message.success('Delete Successful' )
              } else {
                this.$message({
                  type:'error',
                  message:res
                });
              }
            }
          )
        }).catch(() => {
        });
      },
			confirmUser() {
				this.$refs.editForm.validate((valid) => {
					if (valid) {
            let params = {
              ...this.editForm,
              majorProjectId: this.id,
					    islhToken: sessionStorage.getItem('islhtoken'),
							memberType: this.editType,
            }
						let url =`${this.$store.state.islhurl}majorProjectMember/add`;
						if(params && params.id) {
							url =`${this.$store.state.islhurl}majorProjectMember/edit`;
						}
						this.confirmLoading = true;
						this._post(url, params).then(
							res => {
                this.confirmLoading = false;
								if(res.code === 200) {
									this.$Message.success('Successful!' );
                	this.handleSearch(this.editType);
                	this.closeEdit();
								} else {
									this.$message.error(res.message || 'Failed!' );
								}
							}
						)
					}
				});
			}
		},
  }
</script>
<style lang="less" scoped>
#weeklyReportUser {
	.el-form {
		padding: 20px 0 20px 0;
		.el-form-item {
			margin-bottom: 20px;
		}
		/deep/.el-form-item__label {
			line-height: 22px;
			padding: 9px 12px 9px 0px;
		}
		/deep/.el-select {
			width: 100%;
		}
		/deep/.el-form-item__content .el-input__suffix {
			left: auto;
			right: 10px;
		}
		/deep/.el-range-editor.el-input__inner {
			width: 100%;
		}
	}
	.el-table {
		/deep/th.el-table__cell>.cell {
			word-break: break-word;
		}
	}
	/deep/.el-dialog__body {
		border-top: 1px solid #e8eaec;
		border-bottom: 1px solid #e8eaec;
		.el-form {
			padding: 0;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/view/major/recipientManagement/index.vue